var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layout,{tag:"component"},[(_vm.busy)?_c('Spinner'):_vm._e(),(_vm.vw)?_c('router-view',{attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }